import { Box } from '@material-ui/core';
import { getMerchantById, getMerchantDataById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';
import { SWRConfig } from 'swr';

import { MerchantBranding } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantBranding/MerchantBranding';
import { MerchantCashInCashOutMethod } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantCashInCashOutMethod/MerchantCashInCashOutMethod';
import { MerchantDetails } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantDetails';
import { MerchantLegalAddress } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantLegalAddress/MerchantLegalAddress';
import { MerchantRegistrationData } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantRegistrationData/MerchantRegistrationData';
import { MerchantToDo } from '@/components/modules/MerchantDetail/MerchantToDo/MerchantToDo';
import { ModuleCorePermissionProps } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { useScreen } from '@/hooks/useScreen';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

interface MerchantOverviewProps extends ModuleCorePermissionProps {
  showInternalData?: boolean;
}

const MerchantOverview = ({ canEdit = false, showInternalData = false }: MerchantOverviewProps) => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: merchant, loading } = useCache(getMerchantById, { merchantId });
  const { data: merchantData, loading: merchantDataLoading } = useCache(getMerchantDataById, { merchantId });

  const { lg } = useScreen();

  useSetPageLoadingWhenRequesting('MERCHANT_OVERVIEW', [loading]);

  if (!merchant) return null;

  return (
    <SWRConfig value={{ revalidateOnMount: false }}>
      <Box display={'flex'} justifyContent={'space-between'} flexDirection={lg ? 'row' : 'column'}>
        <MerchantDetails merchant={merchant} showInternalData={showInternalData} />
        <Box mt={4} />
        {canEdit && <MerchantToDo />}
      </Box>
      <Box mt={4} />
      <MerchantRegistrationData merchant={merchant} editModeAllowed={canEdit} showInternalData={showInternalData} />
      <Box mt={2} />
      {showInternalData && (
        <>
          <MerchantLegalAddress merchant={merchant} merchantData={merchantData} editModeAllowed={canEdit} />
          <Box mt={2} />
          <MerchantCashInCashOutMethod merchant={merchant} merchantData={merchantData} editModeAllowed={canEdit} />
          <Box mt={2} />
        </>
      )}
      <MerchantBranding
        merchantId={merchant.id}
        merchantData={merchantData}
        merchantDataLoading={merchantDataLoading}
        editModeAllowed={canEdit}
      />
    </SWRConfig>
  );
};

export const MerchantOverviewModule = withPermissionsModule(MerchantOverview);
